export const hasAdvisorAccess = (property = {}) => {
  const plan = (property.plan || "").toString().toLowerCase();
  if (plan === "pro" || plan === "premium" || plan === "impulso") return true;

  // Las propiedades editoriales anteriores a los planes conservan acceso.
  return property.source !== "supabase";
};
